export interface ISearchResult {
    id: string | number;
    title: string;
    subtitle?: string;
    devSubtitle?: string;
    /** Categoría del resultado de búsqueda */
    category: ESearchCategory | string;
    /** Acción a ejecutar al seleccionar el resultado "Enter" */
    action: () => void;
    children?: TSearchChildResult[];
}

export type TSearchChildResult = Omit<ISearchResult, "children">;

export interface ISearchProvider {
    key: string; // "alumno", "docente"
    label: string;
    subLabel?: string;
    search: (query: string) => ISearchResult[];
    action?: () => void;
}

export enum ESearchCategory {
    RECENT = 'Recientes',
    MODULES = 'Módulos',
    // ENTITIES = 'Entidades',
    OTROS = 'Otros'
}

export interface IGlobalSearchSelectEventDetail {
    text: string;
    result: ISearchResult;
}